import { useState, useEffect } from 'react';

import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from '../../../components/SelecaoAmparoLegal';

import {
  classNames,
  isFormFieldValid,
  printToast,
  summaryCriacaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  summaryAlteracaoSucessoPadrao,
  detailAlteracaoSucessoPadrao,
  getFormErrorMessage,
} from "../../../config/global";

import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from "primereact/dropdown";

import { useFormik } from 'formik';
import formikValidation from './formikValidation';

import RotuloSeplag from '../../../components/RotuloSeplag';
import ModalSeplag from '../../../components/ModalSeplag';

import {
  salvar as salvarCertidao,
  atualizar as atualizarCertidao,
  pesquisarAll as pesquisarAllCertidao
} from '../../../service/manterTiposCertidao';

import {
  buscarSemTipoCertidao as PesquisarAmparoSemTipoCertidao
} from '../../../service/ManterAmparoLegal'

import { pesquisarAll as pesquisarAllOrgaos } from "../../../service/Orgao";

import { Button } from 'primereact/button';

const ModalCadastroCertidao = (
  {
    handleCloseModalEditarTipoCertidao,
    handleCloseModalAdicionarTipoCertidao,
    showForm,
    form,
    edit,
    setShowForm,
    view,
    setDataTable
  }) => {

  const amparo = useSelecaoAmparoLegal({ amparos: form.listaAmparoLegal });
  const [optionsOrgaoOrigemAtoAdministrativo, setOptionsOrgaoOrigemAtoAdministrativo] = useState([]);

  const [optionsAmparoLegal, setOptionsAmparoLegal] = useState([]);

  useEffect(() => {
    pesquisarAllOrgaos().then((res) => {
      setOptionsOrgaoOrigemAtoAdministrativo(res)
    })


    PesquisarAmparoSemTipoCertidao().then(res => {

      setOptionsAmparoLegal(res);
    })
  }, [])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => {
      data.listaAmparo = amparo.justificativasSelecionada
      return formikValidation(data)
    },
    onSubmit: async (data) => {
      const { idenTipoCertidao } = data;

      const formData = {
        listaAmparoLegal: data.listaAmparo,
        // amparoLegal: data.listaAmparo.length >= 0 ? data.listaAmparo[0]: null,
        codgTipoCertidao: data.codgTipoCertidao,
        nomeTipoCertidao: data.nomeTipoCertidao,
        siglTipoCertidao: data.siglTipoCertidao,
        orgaoEmissor: data.orgaoEmissor
      }

      if (edit) {
        await atualizarCertidao(formData, idenTipoCertidao).then(() => {
          pesquisarAllCertidao().then((res) => {
            setDataTable(res);
          });

          let summary;
          let detail;
          summary = summaryAlteracaoSucessoPadrao;
          detail = detailAlteracaoSucessoPadrao;

          setTimeout(() => {
            printToast({ summary, detail });
          }, 0)
          setShowForm(false);
        });
      }
      else {
        await salvarCertidao(formData).then((res) => {
          pesquisarAllCertidao().then((res) => {
            setDataTable(res);
          });

          let summary;
          let detail;

          if (res.type === "INS") {
            summary = summaryCriacaoSucessoPadrao;
            detail = detailCriacaoSucessoPadrao;
          } else {
            summary = summaryAlteracaoSucessoPadrao;
            detail = detailAlteracaoSucessoPadrao;
          }
          setTimeout(() => {
            printToast({ summary, detail });
          }, 0)
          setShowForm(false);
        });
      }
    }
  });

  return (
    <ModalSeplag
      type={"NONE"}
      titulo={edit ? "Editar Tipo de Certidão de Crédito" : "Cadastrar Tipo de Certidão de Crédito"}
      fechar={handleCloseModalAdicionarTipoCertidao}
      tamanho={"1000px"}
      header="Detalhes da Obrigação"
      visible={showForm}
      onHide={handleCloseModalEditarTipoCertidao}
      edit={edit}
    >
      <form onSubmit={formik.handleSubmit} className="p-grid">

        <RotuloSeplag obrigatorio nome="Código" cols="12 4">
          <InputNumber disabled={view} id="codgTipoCertidao"
            useGrouping={false}
            value={formik.values.codgTipoCertidao}
            onValueChange={(e) => formik.handleChange(e)}
            placeholder="Digite o código"
          />
          {getFormErrorMessage("codgTipoCertidao", formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Especificação" cols="12 4">
          <InputText disabled={view} id="nomeTipoCertidao"
            value={formik.values.nomeTipoCertidao}
            onChange={(e) => formik.handleChange(e)}
          />
          {getFormErrorMessage('nomeTipoCertidao', formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Sigla" cols="12 4">
          <InputText disabled={view} id="siglTipoCertidao"
            value={formik.values.siglTipoCertidao}
            onChange={(e) => formik.handleChange(e)}
          />
          {getFormErrorMessage('siglTipoCertidao', formik)}
        </RotuloSeplag>

        <RotuloSeplag nome="Órgão Emissor" obrigatorio cols="12 4">
          <Dropdown
            filter
            id="orgaoEmissor"
            name="orgaoEmissor"
            //optionValue='idenOrgao'
            optionLabel="descOrgao"
            options={optionsOrgaoOrigemAtoAdministrativo}
            value={formik.values.orgaoEmissor}
            onChange={(e) => formik.handleChange(e)}
            placeholder="Selecione..."
            className={classNames({ "p-invalid": isFormFieldValid("orgaoEmissor", formik) })} />
          {getFormErrorMessage("orgaoEmissor", formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Seleção de Amparo Legal" cols="12">
          <SelecaoAmparoLegalRender
            id="idenAmparoLegal"
            value={formik.values.idenAmparoLegal}
            options={optionsAmparoLegal}
            onChange={(e) => formik.handleChange(e)}
            placeholder="Selecione"
            {...amparo}
          />
          {getFormErrorMessage("idenAmparoLegal", formik)}
        </RotuloSeplag>



        <div style={{ marginBottom: "20vh" }}></div>

        <div className="p-col-12 p-md-3">
          <Button
            label={edit ? 'Editar' : "Enviar"}
            icon={edit ? "pi pi-pencil" : "pi pi-check"}
            autoFocus
            className="p-button-raised margin-app-entre-button"
            type="submit"
          />
        </div>
        <div className="p-col-12 p-md-3">
          <Button
            type='button'
            label="Cancelar"
            icon="pi pi-times"
            onClick={handleCloseModalAdicionarTipoCertidao}
            className="p-button-outlined p-button-danger p-mb-1"
          />
        </div>
      </form>
    </ModalSeplag>
  );
}

export default ModalCadastroCertidao;
